<template>
  <div class="conteudo-aula">
    <iframe v-if="$empresaUtils.temAcesso($tipoAcesso.SALA_DE_AULA_TOPICO_EXPERIENCIA_IMERSIVA.nome, $configEmpresa.rotasRestritasAcesso)" :src="this.ementaCurso.topico_escolhido.url"
      width="100%"
      height="450vh"
      allow="xr-spatial-tracking,gyroscope,accelerometer,fullscreen"
    ></iframe>
    <div class="conteudo-aula-experiencia-imersiva-indisponivel text-center" v-else>
      <div class="row">
        <div class="col-12">
          <p class="titulo-experiencia-imersiva-indisponivel mb-3">Essa simulação 3D não está disponível para essa universidade</p>
          <p class="sub-titulo-experiencia-imersiva-indisponivel mb-3">Infelizmente esse material não está disponível no pacote de conteúdos assinado pela sua universidade</p>
          <p class="sub-titulo-experiencia-imersiva-indisponivel-entre-em-contato mb-4">Entre em contato com a sua universidade para ver a disponibilidade desse conteúdo</p>
          <p><router-link class="experiencia-imersiva-indisponivel-proximo-topico" :to="{path: '/sala-de-aula/'+ementaCurso.topico_posterior}" v-html="'Clique para ver o próximo tópico'"></router-link></p>
        </div>
        <div class="col-8 col-md-6">
          <img src="../../../../assets/img/conteudo-indiposnivel-universidade-1.png" class="img-experiencia-imersiva-indisponivel-1 img-fluid pl-3 pl-md-0 mt-4 mt-md-0">
        </div>
        <div class="col-4 col-md-6">
          <img src="../../../../assets/img/conteudo-indiposnivel-universidade-2.png" class="img-experiencia-imersiva-indisponivel-2 img-fluid d-none d-md-inline-block">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TopicoExperienciaImersiva',
  props: {
    ementaCurso: {
      type: Object,
      required: true
    }
  }
}
</script>
